import * as React from 'react'
import styled from 'styled-components'
import { InputCss } from './Input'

export const BaseTextField = styled.input`
  ${InputCss}
`
